import { takeEvery, takeLatest } from 'redux-saga/effects';

import {
  EDITOR_KEYBOARD_DELETE,
  EDITOR_COPY,
  EDITOR_CUT,
  EDITOR_PASTE,
  EDITOR_REDO,
  EDITOR_UNDO
} from 'js/actionCreators/editorActions';

import { copy } from './editorSagas/copy';
import { deleteSaga } from './editorSagas/delete';
import { paste } from './editorSagas/paste';
import { cut } from './editorSagas/cut';
import { undo } from './editorSagas/undo';
import { redo } from './editorSagas/redo';

export default function* editorSagas() {
  yield takeEvery(EDITOR_KEYBOARD_DELETE, deleteSaga);
  yield takeLatest(EDITOR_CUT, cut);
  yield takeEvery(EDITOR_COPY, copy);
  yield takeLatest(EDITOR_PASTE, paste);
  yield takeLatest(EDITOR_UNDO, undo);
  yield takeLatest(EDITOR_REDO, redo);
}
